import { formatCurrency } from 'common/constants/currency';
import * as yup from 'yup';

export const priceSchema = (allowZeroLMI: boolean, maxPrice?: number) =>
  yup.object({
    price: yup
      .number()
      .required('Preço é obrigatório')
      .min(allowZeroLMI ? 0 : 0.01, 'O valor deve ser maior que R$0,00')
      .max(maxPrice ? maxPrice : Infinity, `O valor deve ser igual ou menor que ${formatCurrency(maxPrice!)}`)
      .typeError('Por favor, informe um novo preço.'),
  });
